import { ExecuteParameters, VerbId as ApiVerbId } from '@tableau/api-internal-contract-js';
import {
  DocCommands as PresLayerDocCommandId,
  SrvCommands as PresLayerSrvCommandId,
  UICommands as PresLayerUICommandId,
} from '../../gen-src/preslayer/CommandIds';
import { ParameterId } from '../../gen-src/preslayer/Params';
import { CommandNamespace, CommandParameter, CommandRegistration } from './CommandRegistration';
import { ApiToPresLayerMappingRegistry } from './ParameterMappingRegistryFactory';

/**
 * Add versioning support to CommandRegistration class.
 **/
export class VersionedCommandRegistration extends CommandRegistration {
  private _apiVersion: string;

  public constructor(
    apiVersion: string,
    apiVerbId: ApiVerbId,
    commandId: PresLayerDocCommandId | PresLayerSrvCommandId | PresLayerUICommandId,
    inputParameters: Array<CommandParameter>,
    outputParameters?: Array<CommandParameter>,
    namespace?: CommandNamespace,
  ) {
    super(apiVerbId, commandId, inputParameters, outputParameters, namespace);
    this._apiVersion = apiVersion;
  }

  private get apiVersion(): string {
    return this._apiVersion;
  }

  /**
   * Creates a dictionary of pres-layer parameters from the input dictionary
   * of api parameters. Appends an api Version to the parameters.
   *
   *
   * @param {ExecuteParameters} parameters - The parameters to convert
   * @param {ApiToPresLayerMappingRegistry} apiToPresLayer - mapping to determine the conversion
   * @returns {{ [paramId: string]: object; }} - parameters to send to the pres-layer
   */
  public createParams(parameters: ExecuteParameters, apiToPresLayer: ApiToPresLayerMappingRegistry): { [paramId: string]: object } {
    let result: { [paramId: string]: object };
    result = super.createParams(parameters, apiToPresLayer);
    if (this.apiVersion) {
      result[ParameterId.VersionName] = this.apiVersion as {};
    }
    return result;
  }
}
